import { HhsghSharedStuderEmployeeApplication } from "./employee-application.model";
import { HhsgSharedStuderFacility } from "./facility.model";
import { HhsgSharedStuderJobTitle } from "./job-title.model";
import { HhsgSharedStuderLeader } from "./leader.model";

export class HhsgSharedStuderEmployee {
	userId: number = -1;
	employeeName: string = '';
	address1: string = '';
	address2: string = '';
	city: string = '';
	dateUpdated: Date;
	departmentId: number = 0;
	divisionId: number = 0;
	email: string = '';
	employeeNumber: string = '';
	facilityId: number = 0;
	firstName: string = '';
	hireDate: Date;
	id: number = -1;
	isArchived: number = 0;
	isDCMActive: boolean = false;
	isDeleted: boolean = false;
	isDeptAdmin: boolean = false;
	isIEActive: boolean = false;
	isLEMActive: boolean = false;
	isMMMActive: boolean = false;
	isPFSActive: boolean = false;
	isRMActive: boolean = false;
	isSEMActive: boolean = false;
	isRateable: boolean = true;
	jobTitleId: number = 0;
	lastName: string = '';
	mobile: string = '';
	name: string = '';
	pager: string = '';
	phone: string = '';
	showPortalTour: boolean = false;
	stateId: number = 0;
	userUpdated: string = '';
	zip: string = '';
	displayName: string = '';
	organizationId: number = -1;
	organizationName: string = '';
	organizationLegacyLink: string = '';
	departmentName: string = '';
	portalRoleId: number = -1;
	portalRoleName: string = '';
	leaderId: number = 0;
	leaderName: string = '';
	leadershipLevelName: string = '';
	jobTitle: HhsgSharedStuderJobTitle;
	isLeader: boolean = false;
	nonRateableBySEM: boolean = true;
	nonRateableByLEM: boolean = true;
	loginName: string = "";
	userName: string = "";
	hasSubordinates: boolean;
	messages: string[];
	divisionName: string;


	leaders: HhsgSharedStuderLeader[];
	facilities: HhsgSharedStuderFacility[];
	applications: HhsghSharedStuderEmployeeApplication[];
}
